
const T_ARRAY =   '[object Array]';
const T_OBJECT =  '[object Object]';
const T_STRING =  '[object String]';

const TO_STRING_FN = Object.prototype.toString;

if (typeof Array.isArray !== 'function') {
    Array.isArray = function<T>(verifiable: any): verifiable is Array<T> {
        return TO_STRING_FN.call(verifiable) === T_ARRAY;
    }
}
export const isArray = Array.isArray;

export function isObject<T = Record<string | keyof Symbol, unknown>>(maybeObj: unknown): maybeObj is T {
    return TO_STRING_FN.call(maybeObj) === T_OBJECT;
}

export function isFunction(maybeFunc: unknown): maybeFunc is Function  {
    return typeof maybeFunc === 'function';
}

export function isStr(maybeStr: unknown): maybeStr is string {
    return TO_STRING_FN.call(maybeStr) === T_STRING;
}

export function isNonEmptyStr(maybeStr: unknown): maybeStr is string {
    return isStr(maybeStr) && maybeStr.length !== 0;
}

export function isNotBlankString(maybeStr: unknown): maybeStr is string {
    return isStr(maybeStr) && maybeStr.trim().length !== 0;
}

export function isNum(maybeNum: unknown): maybeNum is number {
    return Number.isFinite(maybeNum);
}

export function isElem(maybeElem: unknown): maybeElem is HTMLElement {
    return maybeElem instanceof HTMLElement;
}

export function isDate(maybeDate: unknown): maybeDate is Date {
    return maybeDate instanceof Date;
}
